<template>
  <v-layout>
    <v-container class="text-xs-center">
      <v-progress-circular
        v-if="loading"
        class="mt-5"
        indeterminate
        :size="70"
        :width="7"
        color="primary"
      ></v-progress-circular>
      <div v-if="!loading">
        <h2>Welcome {{ name }}.</h2>
        <h3>Role {{ role }}</h3>
        <img src="static/img/Cubo-Logo.png" />
      </div>
    </v-container>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    name() {
      return this.$store.getters.userData.Name;
    },
    role() {
      return this.$store.getters.userData.Role;
    },
    access() {
      return this.$store.getters.userData.Access;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Welcome.vue?14466acb